import React from "react";
import { Switch, Redirect, Route } from "react-router-dom";
import FeedbackPage from "../pages/feedback-page/feedback-page.component";
import QuizPage from "../pages/student/quiz-page/quiz-page.component";
import TakeQuizPage from "../pages/student/quiz-page/take-quiz-page/take-quiz-page.component";
import ScorePage from "../pages/student/quiz-page/score-page/score-page.component";
import ScoresPage from "../pages/student/scores-page/scores-page.component";
import LogOut from "../pages/logout/logout.component";
import HomePage from "../pages/home-page/home-page.component";

export default function StudentRoutes() {
    return (
        <>
            <Switch>
                <Route exact path="/home" component={HomePage} />
                <Route exact path="/quiz" component={QuizPage} />
                <Route exact path="/quiz/:id" component={TakeQuizPage} />
                <Route exact path="/quiz/:id/score" component={ScorePage} />
                <Route exact path="/scores" component={ScoresPage} />
                <Route exact path="/feedback" component={FeedbackPage} />
                <Route exact path="/log-out" component={LogOut} />
                <Redirect exact to="/home" />
            </Switch>
        </>
    );
}
